/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProcessOfflineEventsDataEventMeta } from './ProcessOfflineEventsDataEventMeta';
import {
    ProcessOfflineEventsDataEventMetaFromJSON,
    ProcessOfflineEventsDataEventMetaFromJSONTyped,
    ProcessOfflineEventsDataEventMetaToJSON,
    ProcessOfflineEventsDataEventMetaToJSONTyped,
} from './ProcessOfflineEventsDataEventMeta';

/**
 * 
 * @export
 * @interface ProcessOfflineEventsDataEvent
 */
export interface ProcessOfflineEventsDataEvent {
    /**
     * 
     * @type {string}
     * @memberof ProcessOfflineEventsDataEvent
     */
    idempotencyKey: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessOfflineEventsDataEvent
     */
    series?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessOfflineEventsDataEvent
     */
    type: ProcessOfflineEventsDataEventTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ProcessOfflineEventsDataEvent
     */
    timestamp: number;
    /**
     * 
     * @type {ProcessOfflineEventsDataEventMeta}
     * @memberof ProcessOfflineEventsDataEvent
     */
    meta: ProcessOfflineEventsDataEventMeta;
}

/**
* @export
* @enum {string}
*/
export enum ProcessOfflineEventsDataEventTypeEnum {
    BreakEnd = 'Break End',
    BreakStart = 'Break Start',
    ClockIn = 'Clock In',
    ClockOut = 'Clock Out'
}


/**
 * Check if a given object implements the ProcessOfflineEventsDataEvent interface.
 */
export function instanceOfProcessOfflineEventsDataEvent(value: object): value is ProcessOfflineEventsDataEvent {
    if (!('idempotencyKey' in value) || value['idempotencyKey'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ProcessOfflineEventsDataEventFromJSON(json: any): ProcessOfflineEventsDataEvent {
    return ProcessOfflineEventsDataEventFromJSONTyped(json, false);
}

export function ProcessOfflineEventsDataEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessOfflineEventsDataEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'idempotencyKey': json['idempotencyKey'],
        'series': json['series'] == null ? undefined : json['series'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'meta': ProcessOfflineEventsDataEventMetaFromJSON(json['meta']),
    };
}

  export function ProcessOfflineEventsDataEventToJSON(json: any): ProcessOfflineEventsDataEvent {
      return ProcessOfflineEventsDataEventToJSONTyped(json, false);
  }

  export function ProcessOfflineEventsDataEventToJSONTyped(value?: ProcessOfflineEventsDataEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idempotencyKey': value['idempotencyKey'],
        'series': value['series'],
        'type': value['type'],
        'timestamp': value['timestamp'],
        'meta': ProcessOfflineEventsDataEventMetaToJSON(value['meta']),
    };
}

